/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Export_Account_Personal_MissingInputs */

const cs_social_export_account_personal_missing = /** @type {(inputs: Social_Export_Account_Personal_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propojte osobní Facebook stránku v nastavení profilu.`)
};

const en_social_export_account_personal_missing = /** @type {(inputs: Social_Export_Account_Personal_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link your personal Facebook Page in profile settings.`)
};

/**
* | output |
* | --- |
* | "Link your personal Facebook Page in profile settings." |
*
* @param {Social_Export_Account_Personal_MissingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_export_account_personal_missing = /** @type {((inputs?: Social_Export_Account_Personal_MissingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Export_Account_Personal_MissingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_export_account_personal_missing(inputs)
	return cs_social_export_account_personal_missing(inputs)
});